export const MEM_AGENT_APP_CALLOUT_ID = "3cd228aa-4216-4da6-996f-3b050d408c45";

export const MEM_AGENT_REMINDERS_APP_CALLOUT_ID = "c6e24ab3-0bef-40e1-8c74-6145738e1647";

export const MEM_AGENT_BANNER_APP_CALLOUT_IDS = [
  MEM_AGENT_REMINDERS_APP_CALLOUT_ID,
  MEM_AGENT_APP_CALLOUT_ID,
];
